import type { JSX } from 'react';
import { useEffect, useState } from 'react';
import type { IGeneralPractitioner } from '@common/interfaces/generalPractitioner';
import type { IPatient } from '@common/interfaces/patient';
import { CareProviderSelection } from '@frontend/components/elements/CareProviderSelection';
import { CheckCareProvider } from '@frontend/components/pages/customControls/utils/v1/CheckCareProvider';

type ProcessCareProviderSelectorProps = Readonly<{
    error?: string;
    generalPractitioner: IGeneralPractitioner;
    isRequired?: boolean;
    itemsPerPage?: number;
    onChange: (organizationId: string | null, practitionerId: string | null) => void;
    patient: IPatient;
}>;

export function ProcessActivityCareProviderSelector(props: ProcessCareProviderSelectorProps): JSX.Element {
    const { patient, generalPractitioner } = props;
    const [showCareProviderSelection, setShowCareProviderSelection] = useState(
        !patient.careProviderPractitionerId || generalPractitioner.practitionerId
    );

    useEffect(() => {
        if (patient.careProviderPractitionerId && !generalPractitioner.practitionerId) {
            props.onChange(patient.careProviderOrganizationId || null, patient.careProviderPractitionerId);
        }
    }, [patient.careProviderPractitionerId, generalPractitioner.practitionerId]);

    if (showCareProviderSelection) {
        return (
            <CareProviderSelection
                error={props.error}
                formlabeltext="Huisarts van de patiënt"
                hasErrors={!!props.error}
                initialOrganizationId={generalPractitioner.organizationId}
                initialPractitionerId={generalPractitioner.practitionerId}
                itemsPerPage={props.itemsPerPage}
                onChange={async (organizationId, practitionerId) => props.onChange(organizationId, practitionerId)}
                patient={patient}
                required={props.isRequired}
                size="medium"
            />
        );
    } else {
        return (
            <CheckCareProvider
                isRequired={props.isRequired}
                onClickChange={() => setShowCareProviderSelection(true)}
                patient={patient}
            />
        );
    }
}
